import { render, staticRenderFns } from "./DogRegistrationIndividualRegistrationSignature.vue?vue&type=template&id=7220e799"
import script from "./DogRegistrationIndividualRegistrationSignature.vue?vue&type=script&lang=ts"
export * from "./DogRegistrationIndividualRegistrationSignature.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports